import { Paquete } from '../../types/catalogo';
import { tieneNombresDuplicados, validarPaquete } from '../../validation/validators';
import { PlusIcon, TrashIcon } from '../shared/icons';

interface Props {
  paquetes: Paquete[];
  onChange: (paquetes: Paquete[]) => void;
}

/** FR-CAT-02/03: editor dinámico de paquetes de precio, con validación en tiempo real. */
export function PackageEditor({ paquetes, onChange }: Props) {
  const duplicados = tieneNombresDuplicados(paquetes);

  const actualizar = (index: number, cambios: Partial<Paquete>) => {
    const copia = paquetes.map((p, i) => (i === index ? { ...p, ...cambios } : p));
    onChange(copia);
  };

  const eliminar = (index: number) => {
    onChange(paquetes.filter((_, i) => i !== index));
  };

  const agregar = () => {
    onChange([...paquetes, { id: crypto.randomUUID(), nombre: '', cantidadEnUnidades: 1, precio: 0 }]);
  };

  return (
    <div className="flex flex-col gap-2.5 border-t border-admin-border pt-5">
      <div className="flex justify-between items-center">
        <span className="text-[13px] font-semibold text-wood">Paquetes de precio</span>
        <button
          type="button"
          onClick={agregar}
          data-testid="package-editor-add-button"
          className="flex items-center gap-1.5 text-xs font-bold text-terracotta"
        >
          <PlusIcon width={13} height={13} /> Agregar paquete
        </button>
      </div>

      {duplicados && (
        <p className="text-xs text-danger">Hay nombres de paquete repetidos (BR-CAT-03)</p>
      )}

      {paquetes.map((paquete, index) => {
        const error = validarPaquete(paquete);
        return (
          <div
            key={paquete.id}
            data-testid={`package-editor-row-${index}`}
            className="grid grid-cols-[2fr_1fr_1fr_32px] gap-2.5 items-center"
          >
            <input
              value={paquete.nombre}
              onChange={(e) => actualizar(index, { nombre: e.target.value })}
              placeholder="Nombre (ej. Docena)"
              className="border border-admin-border rounded-md px-3 py-2.5 text-[13px]"
            />
            <input
              type="number"
              value={paquete.cantidadEnUnidades}
              onChange={(e) => actualizar(index, { cantidadEnUnidades: Number(e.target.value) })}
              className="border border-admin-border rounded-md px-3 py-2.5 text-[13px]"
            />
            <input
              type="number"
              step="0.01"
              value={paquete.precio}
              onChange={(e) => actualizar(index, { precio: Number(e.target.value) })}
              className="border border-admin-border rounded-md px-3 py-2.5 text-[13px]"
            />
            <button
              type="button"
              onClick={() => eliminar(index)}
              aria-label={`Eliminar paquete ${index + 1}`}
              className="text-danger"
            >
              <TrashIcon width={15} height={15} />
            </button>
            {error && <p className="col-span-4 text-xs text-danger -mt-1.5">{error}</p>}
          </div>
        );
      })}
    </div>
  );
}
